import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import {
  Form,
  Input,
  Button,
  Typography,
  Row,
  Col,
  Spin,
  Alert,
  Result,
} from "antd";
import logofull from "../assets/logo.png";
import axios from "axios";

const {Title} = Typography
const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };
const ForgotPassword = () => {
    const isLoggedIn = useSelector(
      (state) => state.user.isLoggedIn && state.user.jwt !== null
    );
    const isFetching = useSelector((state) => state.user.isFetching);

    const [sent, setSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState();



    const onFinish = (values) => {
        setLoading(true);
        axios.post(process.env.REACT_APP_BACKEND+"/auth/forgot-password",{
       // axios.post('http://localhost:1337/auth/forgot-password', {
        // axios.post('https://odin-bf0c8.ew.r.appspot.com/auth/forgot-password', {
                email: values.email, 
            })
            .then(response => {
                setSent(true);
                setLoading(false);
            })
            .catch(error => {
                console.log('An error occurred:', error.response);
                let errorMessage = 'Network Error'
                if (error.response) {
                    errorMessage = error.response.data.message[0].messages[0].message
                    //console.log('An error occurred PROBLEEM:', errorMessage);
                }
                setError(true);
                setErrorMessage(errorMessage)
                setLoading(false);
            });
      };
    
      const onFinishFailed = (errorInfo) => {
        console.log("Failed:", errorInfo);
      };

    const resetForm = (
        <Form
          {...layout}
          name="basic"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
            <Row>
                <Title level={5}>Password reset link will be sent to your e-mail.</Title>
            </Row>
          <Form.Item
            label="E-mail"
            name="email"
            rules={[
              {
                required: true,
                message: "Please enter your email!",
                type: "email",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Row>
            <Button type="primary" htmlType="submit" block>
              Send me reset link
            </Button>
          </Row>
        </Form>
      );
    



    if (isLoggedIn) return <Redirect to="/" />
    return (
        <div className="reset-form">
        <Row
          type="flex"
          justify="center"
          align="middle"
          style={{ minHeight: "100vh" }}
        >
        {error && (
          <Alert
            message={errorMessage}
            type="error"
            closable
            showIcon
            banner
            style={{ position: "absolute", top: "50px" }}
          />
        )}
          <Col>
            <Spin spinning={isFetching || loading} delay={100}>
              <img
                src={logofull}
                alt="Logo"
                className="logo-full"
                style={{ marginBottom: 15 }}
              />
              { sent ?
                <Result
                    status="success"
                    title="Password reset email been sent."
                    subTitle="Check your inbox. Be sure to also check spam box."
                />         
                :resetForm
              }
            </Spin>
          </Col>
        </Row>
      </div>
    )
}

export default ForgotPassword
